export const functionNames = {
  avg: 'avg',
  categoryItemProp: 'categoryItemProp',
  count: 'count',
  dateTimeDiff: 'dateTimeDiff',
  distance: 'distance',
  first: 'first',
  geoCoordinateAtDistance: 'geoCoordinateAtDistance',
  geoDistance: 'geoDistance',
  geoPolygon: 'geoPolygon',
  includes: 'includes',
  index: 'index',
  isEmpty: 'isEmpty',
  isNotEmpty: 'isNotEmpty',
  last: 'last',
  ln: 'ln',
  log10: 'log10',
  max: 'max',
  min: 'min',
  now: 'now',
  numberToWords: 'numberToWords',
  parent: 'parent',
  pow: 'pow',
  prevCycleValue: 'prevCycleValue',
  prevCycleValues: 'prevCycleValues',
  recordCycle: 'recordCycle',
  recordDateCreated: 'recordDateCreated',
  recordDateLastModified: 'recordDateLastModified',
  recordOwnerEmail: 'recordOwnerEmail',
  recordOwnerName: 'recordOwnerName',
  recordOwnerRole: 'recordOwnerRole',
  sum: 'sum',
  taxonProp: 'taxonProp',
  taxonVernacularName: 'taxonVernacularName',
  unique: 'unique',
  userEmail: 'userEmail',
  userIsRecordOwner: 'userIsRecordOwner',
  userName: 'userName',
  userProp: 'userProp',
  uuid: 'uuid',
}

// Functions whose result depends on the currently logged in user;
// expressions using them must be re-evaluated for the current user on every record fetch.
export const userDependentFunctionNames = [
  functionNames.userEmail,
  functionNames.userIsRecordOwner,
  functionNames.userName,
  functionNames.userProp,
]
